import { ReactComponent as DiscordLogo } from '../assets/social-media/discord.svg';
import { ReactComponent as FacebookLogo } from '../assets/social-media/facebook.svg';
import { ReactComponent as InstagramLogo } from '../assets/social-media/instagram.svg';
import { ReactComponent as TelegramLogo } from '../assets/social-media/telegram.svg';
import { ReactComponent as TwitterLogo } from '../assets/social-media/twitter.svg';
import { ReactComponent as YoutubeLogo } from '../assets/social-media/youtube.svg';

import { SOCIAL_MEDIA_LINKS } from './social-media-links.constants';

export const socialMediaItems = [
  {
    ImageComponent: TwitterLogo,
    alternativeText: 'Twitter',
    link: SOCIAL_MEDIA_LINKS.twitter,
  },
  {
    ImageComponent: TelegramLogo,
    alternativeText: 'Telegram',
    link: SOCIAL_MEDIA_LINKS.telegram,
  },
  {
    ImageComponent: DiscordLogo,
    alternativeText: 'Discord',
    link: SOCIAL_MEDIA_LINKS.discord,
  },
  {
    ImageComponent: YoutubeLogo,
    alternativeText: 'YouTube',
    link: SOCIAL_MEDIA_LINKS.youtube,
  },
  {
    ImageComponent: InstagramLogo,
    alternativeText: 'Instagram',
    link: SOCIAL_MEDIA_LINKS.instagram,
  },
  {
    ImageComponent: FacebookLogo,
    alternativeText: 'Facebook',
    link: SOCIAL_MEDIA_LINKS.facebook,
  },
];
